import { UserStaffInfo } from './user-staff-info';

export class HelloResults {
    public ActiveMac: boolean = false;
    public CentralServer: string = '';
    public ClientFileVersion: string = '';
    public ClientFileVersion7: string = '';
    public ClientVersion: string = '';
    public ClientVersion7: string = '';
    public Expires: Date = new Date();
    public HelpPath: string = '';
    public HomeDatabase: string = '';
    public HomeIP: string = '';
    public HomeProgram: string = '';
    public Monitor: boolean = false;
    public Printers: any = null;
    public PrivateChannels: any = null;
    public ServerManager: boolean = false;
    public SessionID: string = '';
    public Supervisor: boolean = false;
    public UserID: string = '';
    public UserName: string = '';
    public UserStaffInfo: UserStaffInfo = new UserStaffInfo();
    public Navigation: any = {};
    public PSTSuiteNavigation?: any = {};
    public CustomCardFields: Array<string> = [];
    public PSTNotificationSettings: any = {
        Email: { Input: '', Recieve: false },
        Mobile: { Recieve: false },
        Phone: { Input: '', Recieve: false },
        Web: { Recieve: false },
    };
    public FtpAvatarLocation: string = '';
    public SecurityPrivileges: Array<any> = [];
    public PersonalTimeZone: string = '';
    public PersonalLanguage: string = '';
    public TeamExportFormatTemplates: { [id: string]: StorytellingExportFormatRecord } = {};
    public EnterpriseExportFormatTemplates: { [id: string]: StorytellingExportFormatRecord } = {};
    public PersonalExportFormatTemplates: { [id: string]: StorytellingExportFormatRecord } = {};
    public TeamClipboardTemplates: Array<any> = [];
    public ClipboardTemplates: Array<any> = [];
    public PersonalClipboardTemplates: Array<any> = [];
    public Rtl: boolean = false;
    public DarkMode: boolean = false;
    public DayOfWeek: number = 0;
    public WalkMe: string = '';
}
